export default __webpack_public_path__ + "static/media/GT-Walsheim-Pro-Bold.b12cee50.ttf";